<ta-loader [isLoading]="this.requestState.isLoading()">
  <div class="role-section flex-column g-space-md">
    @if (showTitle()) {
      <ta-title [level]="3">{{ 'app.user.components.role_selection.title' | translate }}</ta-title>
    }
    <div class="toggle-cards-container">
      <ta-toggle-card
        [title]="'app.user.components.role_selection.tenant_title' | translate"
        [description]="'app.user.components.role_selection.tenant_description' | translate"
        icon="frame_person"
        [isActive]="this.isTenantActive()"
        (toggle)="this.onTenantToggle($event)"
      ></ta-toggle-card>

      <ta-toggle-card
        [title]="'app.user.components.role_selection.owner_title' | translate"
        [description]="'app.user.components.role_selection.owner_description' | translate"
        icon="apartment"
        [isActive]="this.isOwnerActive()"
        (toggle)="this.onOwnerToggle($event)"
      ></ta-toggle-card>
    </div>
  </div>
</ta-loader>
